// import {
//   Button,
//   Card,
//   Col,
//   Form,
//   Icon,
//   Input,
//   notification,
//   Row,
//   Select,
//   Table,
//   Tooltip
// } from 'antd'
// import _ from 'lodash'
// import moment from 'moment'
// import { push } from 'connected-react-router'
// import React, { PureComponent } from 'react'
//
// import { connect } from 'react-redux'
// import GetEachFormFields from '../../components/_utils/appFormUtils'
// import {getUrlParams } from '../../routes'
// import {
//   createAbstractFxn,
//   lastAbstractNo,
//   FetchSingleOnlineAbstractAction,
//   proceedAbstractSubmissionFxn
// } from './actions'
//
// import PageHeaderWrapper from '../../components/PageHeaderWrapper'
// import {
//   chooseEmailModalFxn,
//   Countries,
//   CustomCkEditor,
//   DesignationList,
//   InputBox, issueTypeList,
//   mentionsFeeds,
//   NotificationBox,
// } from '../../components/_utils/appUtils'
// import { JournalList } from '../journals/actions'
//
// @Form.create()
// class AddAbstract extends PureComponent {
//   state = {
//     journalListArr: [],
//     authors: [],
//     abstractFile: {},
//     copyrightForm: {},
//     supportingFile: {},
//     fileKey: moment(),
//     abstract: '',
//     titleHtml: '',
//     lastAbstractNo: ''
//   }
//   updateDocumentTitle = () => {
//     const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//     const isEditFlow = getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     if (isProceedFlow) {
//       document.title = 'Proceed Abstract Submission - Arcc Journals'
//     } else if (isEditFlow) {
//       document.title = 'Edit Abstract - Arcc Journals'
//     } else {
//       document.title = 'Add Abstract - Arcc Journals'
//     }
//   }
//
//   componentDidMount() {
//     this.loadJournalList()
//     this.props.form.setFieldsValue({ submittedDate: moment() })
//     this.loadLastAbstractNo()
//     this.updateDocumentTitle()
//
//     const params = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     if (params && params.id) {
//       this.loadAndPrefillAbstractData(params.id)
//     }
//   }
//
//   componentDidUpdate(prevProps) {
//     if (this.props.pathname !== prevProps.pathname) {
//       const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//       document.title = isProceedFlow ? 'Proceed Abstract Submission - Arcc Journals' : 'Add Abstract - Arcc Journals'
//     }
//
//     const prevParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', prevProps.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', prevProps.pathname)
//     const currentParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     const prevId = prevParams ? prevParams.id : null
//     const currentId = currentParams ? currentParams.id : null
//
//     if (currentId && currentId !== prevId) {
//       this.loadAndPrefillAbstractData(currentId)
//     }
//   }
//
//   loadAndPrefillAbstractData = async (id) => {
//     const { dispatch, form: { setFieldsValue } } = this.props
//
//     let resp = await dispatch(FetchSingleOnlineAbstractAction(id))
//
//     if (resp && resp.success && resp.data) {
//       const record = resp.data
//
//       let journalValue = record.journal
//       if (journalValue && typeof journalValue === 'object') {
//         journalValue = journalValue._id
//       }
//       setFieldsValue({
//         journal: journalValue,
//         issueType: record.issueType,
//         titleOfAbstract: record.titleOfAbstract,
//         researchArea: record.researchArea,
//         publicationCharges: record.publicationCharges,
//         abstractNo: record.abstractNo || record.abstractId,
//         authorName: record.authorName,
//         email: record.email,
//         mobile: record.mobile,
//         institution: record.institution,
//         designation: record.designation,
//         country: record.country,
//         orcidId: record.orcidId,
//         keywords: record.keywords || [],
//         speakerNote: record.speakerNote
//       })
//
//       this.setState({
//         authors: record.coAuthors || [],
//         abstract: record.abstract || '',
//         titleHtml: record.titleOfAbstract || ''
//       })
//     }
//   }
//
//   loadJournalList = async () => {
//     let { data } = await JournalList()
//     this.setState({ journalListArr: data || [] })
//   }
//
//   chooseDocument = e => {
//     let { name, files } = e.target
//     if (files && files.length) {
//       this.setState({ [name]: files[0] })
//     }
//   }
//   // loadLastAbstractNo = async () => {
//   //   let { form: { setFieldsValue }, dispatch } = this.props
//   //   let resp = await dispatch(lastAbstractNo({}))
//   //
//   //   if (resp) {
//   //     this.setState({ lastAbstractNo: resp })
//   //     // setFieldsValue({ abstractNo: resp });
//   //   }
//   // }
//   // loadLastAbstractNo = async () => {
//   //   let { form: { getFieldValue }, dispatch } = this.props
//   //
//   //   // 1. Grab the currently selected journal from the form
//   //   let selectedJournal = getFieldValue('journal')
//   //
//   //   // 2. Package it up
//   //   let payload = {
//   //     journalId: selectedJournal || null
//   //   }
//   //
//   //   // 3. Send it to the backend
//   //   let resp = await dispatch(lastAbstractNo(payload))
//   //
//   //   if (resp) {
//   //     this.setState({ lastAbstractNo: resp })
//   //   }
//   // }
//   // loadLastAbstractNo = async () => {
//   //   let { form: { getFieldValue, setFieldsValue }, dispatch } = this.props
//   //
//   //   // Check if we are in Proceed or Edit flow
//   //   const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//   //   const isEditFlow = getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//   //
//   //   let selectedJournal = getFieldValue('journal')
//   //   let payload = { journalId: selectedJournal || null }
//   //
//   //   let resp = await dispatch(lastAbstractNo(payload))
//   //
//   //   if (resp) {
//   //     this.setState({ lastAbstractNo: resp })
//   //     if (!isProceedFlow && !isEditFlow) {
//   //       setFieldsValue({ abstractId: resp })
//   //     }
//   //   }
//   // }
//   loadLastAbstractNo = async () => {
//     let { form: { getFieldValue }, dispatch } = this.props
//
//     let selectedJournal = getFieldValue('journal')
//
//     // 1. Guard: Don't do anything if no journal is selected
//     if (!selectedJournal) return;
//
//     let payload = { journalId: selectedJournal }
//
//     // 2. Fetch the exact last string from the backend (e.g., "LC 10005")
//     let resp = await dispatch(lastAbstractNo(payload))
//
//     if (resp) {
//       // 3. Put it directly into the green badge so the admin can read it!
//       this.setState({ lastAbstractNo: resp })
//     } else {
//       this.setState({ lastAbstractNo: 'No previous abstracts' })
//     }
//   }
//   addMoreAuthor = () => {
//     const { form: { getFieldsValue, setFieldsValue } } = this.props
//     const coAuthorFields = [
//       'coAuthorName',
//       'coAuthorEmail',
//       'coAuthorAffiliation',
//       'coAuthorCountry',
//       'coAuthorOrcid'
//     ]
//
//     const values = getFieldsValue(coAuthorFields)
//
//     if (!values.coAuthorName || !values.coAuthorEmail || !values.coAuthorAffiliation || !values.coAuthorCountry) {
//       notification.error({
//         message: 'Missing Co-Author Fields',
//         description: 'Please fill in Full Name, Email, Affiliation, and Country before adding.'
//       })
//       return
//     }
//
//     let cloneAuthors = _.clone(this.state.authors)
//     cloneAuthors.push({
//       name: values.coAuthorName,
//       email: values.coAuthorEmail,
//       affiliation: values.coAuthorAffiliation,
//       country: values.coAuthorCountry,
//       orcidId: values.coAuthorOrcid
//     })
//
//     this.setState({ authors: cloneAuthors }, () => {
//       setFieldsValue({
//         coAuthorName: '',
//         coAuthorEmail: '',
//         coAuthorAffiliation: '',
//         coAuthorCountry: undefined,
//         coAuthorOrcid: ''
//       })
//     })
//   }
//
//   removeAuthorSubmit = index => {
//     let cloneAuthors = _.clone(this.state.authors)
//     cloneAuthors.splice(index, 1)
//     this.setState({ authors: cloneAuthors })
//   }
//   // handleSubmit = e => {
//   //   const { dispatch, form } = this.props
//   //   e.preventDefault()
//   //
//   //   form.validateFieldsAndScroll(async (err, valData) => {
//   //     if (!err) {
//   //       console.log('PAYLOAD DATA BEING SENT:', valData)
//   //       const { authors, abstract, titleHtml, abstractFile, copyrightForm, supportingFile } = this.state
//   //
//   //       let fd = new FormData()
//   //       const cleanValData = _.omit(valData, [
//   //         'coAuthorName',
//   //         'coAuthorEmail',
//   //         'coAuthorAffiliation',
//   //         'coAuthorCountry',
//   //         'coAuthorOrcid'
//   //       ])
//   //       const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//   //       console.log('valData contents:', valData)
//   //       console.log('isProceedFlow contents:', isProceedFlow)
//   //       const payload = {
//   //         ...cleanValData,
//   //         coAuthors: authors,
//   //         titleOfAbstract: titleHtml || valData.titleOfAbstract,
//   //         abstract: abstract,
//   //         keywords: valData.keywords || [],
//   //         orcidId: valData.orcidId,
//   //         abstractId: valData.abstractId,
//   //         id: isProceedFlow ? isProceedFlow.id : null
//   //       }
//   //
//   //       let response
//   //
//   //       if (isProceedFlow) {
//   //         payload.status = 'Processed'
//   //
//   //         fd.append('obj', JSON.stringify(payload))
//   //         fd.append('abstractFile', abstractFile)
//   //         if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//   //         if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//   //
//   //         response = await dispatch(proceedAbstractSubmissionFxn(fd))
//   //
//   //       } else {
//   //         fd.append('abstract', JSON.stringify(payload)) // Creation route reads 'abstract'
//   //         fd.append('abstractFile', abstractFile)
//   //         if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//   //         if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//   //
//   //         response = await createAbstractFxn(fd)
//   //       }
//   //
//   //       if (response && response.success) {
//   //         NotificationBox({
//   //           title: isProceedFlow ? 'Abstract Processed Successfully' : 'Abstract Submitted Successfully',
//   //           callback: () => {
//   //             form.resetFields()
//   //             this.setState({ authors: [], abstract: '', titleHtml: '', fileKey: moment() })
//   //             form.setFieldsValue({ submittedDate: moment() })
//   //             this.loadLastAbstractNo()
//   //
//   //             // Pushes the user back to the list cleanly
//   //             dispatch(push('/abstract/submittedAbstracts'))
//   //           }
//   //         })
//   //       } else {
//   //         notification.error({ message: (response && response.message) || 'Submission failed' })
//   //       }
//   //     }
//   //   })
//   // }
//   handleSubmit = e => {
//     const { dispatch, form } = this.props
//     e.preventDefault()
//
//     form.validateFieldsAndScroll(async (err, valData) => {
//       if (!err) {
//         console.log('PAYLOAD DATA BEING SENT:', valData)
//         const { authors, abstract, titleHtml, abstractFile, copyrightForm, supportingFile } = this.state
//         const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//         //
//         // let fd = new FormData()
//         const cleanValData = _.omit(valData, [
//           'coAuthorName',
//           'coAuthorEmail',
//           'coAuthorAffiliation',
//           'coAuthorCountry',
//           'coAuthorOrcid'
//         ])
//
//         const payload = {
//           ...cleanValData,
//           coAuthors: authors,
//           titleOfAbstract: titleHtml || valData.titleOfAbstract,
//           abstract: abstract,
//           keywords: valData.keywords || [],
//           orcidId: valData.orcidId,
//           abstractId: valData.abstractId,
//           id: isProceedFlow ? isProceedFlow.id : null
//         }
//         if (!abstractFile || !abstractFile.name) {
//           notification.error({ message: 'Please select an Abstract File' })
//           return
//         }
//         if (!isProceedFlow && (!copyrightForm || !copyrightForm.name)) {
//           notification.error({ message: 'Please select a Copyright Form' })
//           return
//         }
//         chooseEmailModalFxn({
//           title: isProceedFlow ? 'Send Acknowledgement' : 'Send Abstract Submission Email',
//           callback: async (email) => {
//             let fd = new FormData()
//             payload.fromEmail = email
//             payload.template = isProceedFlow ? 'abstractProceedAcknowledgement' : 'abstractSubmissionAcknowledgement'
//             console.log('valData contents:', valData)
//             console.log('isProceedFlow contents:', isProceedFlow)
//
//             let response
//
//             if (isProceedFlow) {
//               payload.status = 'Processed'
//               fd.append('obj', JSON.stringify(payload))
//               fd.append('abstractFile', abstractFile)
//               if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//               if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//               response = await dispatch(proceedAbstractSubmissionFxn(fd))
//             } else {
//               fd.append('abstract', JSON.stringify(payload))
//               fd.append('abstractFile', abstractFile)
//               if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//               if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//               // response = await createAbstractFxn(fd)
//               response = await dispatch(createAbstractFxn(fd))
//             }
//
//             if (response && response.success) {
//               NotificationBox({
//                 title: isProceedFlow ? 'Abstract Processed Successfully' : 'Abstract Submitted Successfully',
//                 callback: () => {
//                   form.resetFields()
//                   this.setState({ authors: [], abstract: '', titleHtml: '', fileKey: moment() })
//                   form.setFieldsValue({ submittedDate: moment() })
//                   this.loadLastAbstractNo()
//                   dispatch(push('/abstract/submittedAbstracts'))
//                 }
//               })
//             } else {
//               notification.error({ message: (response && response.message) || 'Submission failed' })
//             }
//           }
//         })
//       }
//     })
//   }
//
//   render() {
//     const { form: { getFieldDecorator, setFieldsValue }, loading } = this.props
//     const { journalListArr, authors, abstract, fileKey, lastAbstractNo } = this.state
//     const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//     const pageTitle = isProceedFlow ? 'Proceed Abstract Submission' : 'Add Abstract'
//
//     document.title = `${pageTitle} - Arcc Journals`
//
//     const formItemLayout = {
//       labelCol: { span: 24 },
//       wrapperCol: { span: 24 }
//     }
//
//     const inputSchma = {
//       abstractFields: [
//         {
//           label: 'Journal / Event',
//           key: 'journal',
//           required: true,
//           showSearch: true,
//           options: journalListArr,
//           keyAccessor: x => x._id,
//           valueAccessor: x => x.name,
//           placeholder: 'Select Journal',
//           type: 'select',
//           onChange: val => {
//             setFieldsValue({ journal: val })
//             this.loadLastAbstractNo()
//           }
//         },
//         {
//           label: 'Issue Type',
//           key: 'issueType',
//           required: true,
//           type: 'select',
//           options: issueTypeList,
//           placeholder: 'Select Issue Type',
//           onChange: val => {
//             setFieldsValue({ issueType: val })
//             console.log('Issue Type Selected:', val)
//           }
//         },
//         {
//           label: 'Title of Abstract',
//           key: 'titleOfAbstract',
//           required: true,
//           span: 24,
//           type: 'text',
//           placeholder: 'Enter the title of your abstract',
//           onChange: (e) => {
//             const value = e.target.value
//             setFieldsValue({ titleOfAbstract: value })
//             this.setState({ titleHtml: value })
//           }
//         },
//         {
//           label: 'Research Area',
//           key: 'researchArea',
//           required: true,
//           type: 'text',
//           placeholder: 'Select Research Area',
//           span: 12
//         },
//         // {
//         //   label: 'Abstract No',
//         //   key: 'abstractId',
//         //   placeholder: 'Enter Abstract No',
//         //   extraBox: (
//         //     <React.Fragment>
//         //       {lastAbstractNo ? (
//         //         <label
//         //           className={'label label-success'}
//         //           style={{ background: '#52c41a', color: '#fff', padding: '2px 8px', borderRadius: '4px' }}
//         //         >
//         //           {lastAbstractNo}
//         //         </label>
//         //       ) : null}
//         //     </React.Fragment>
//         //   )
//         // },
//         {
//           label: 'Abstract No',
//           key: 'abstractId',
//           placeholder: 'Enter Abstract No',
//
//           onChange: (val) => {
//             setFieldsValue({ abstractId: val.target.value.toUpperCase() });
//           },
//           extraBox: (
//             <React.Fragment>
//               {lastAbstractNo ? (
//                 <label
//                   className={'label label-success'}
//                   style={{ background: '#52c41a', color: '#fff', padding: '2px 8px', borderRadius: '4px' }}
//                 >
//                   {lastAbstractNo}
//                 </label>
//               ) : null}
//             </React.Fragment>
//           )
//         },
//         {
//           label: 'Publication Charges',
//           key: 'publicationCharges',
//           required: true,
//           type: 'number',
//           placeholder: 'Enter Publication Charges',
//           span: 12
//         },
//       ],
//       authorFields: [
//         {
//           label: 'Author Name',
//           key: 'authorName',
//           required: true,
//           placeholder: 'Full name of the corresponding author'
//         },
//         { label: 'Email', key: 'email', required: true, placeholder: 'name@email.com' },
//         { label: 'Mobile Number', key: 'mobile', required: true, placeholder: 'enter mobile no.' },
//         {
//           label: 'Institution / Affiliation',
//           required: true,
//           key: 'institution',
//           placeholder: 'Enter your institution'
//         },
//         {
//           label: 'Designation',
//           key: 'designation',
//           type: 'select',
//           required: true,
//           options: DesignationList,
//           placeholder: 'Select Designation',
//           onChange: val => {
//             setFieldsValue({ designation: val })
//             console.log('Designation Selected:', val)
//           }
//         },
//         {
//           label: 'Select Country',
//           key: 'country',
//           required: true,
//           type: 'select',
//           options: Countries,
//           keyAccessor: x => x.name,
//           valueAccessor: x => x.name,
//           showSearch: true,
//           onChange: val => {
//             setFieldsValue({ country: val })
//             console.log('Main Author Country Selected:', val)
//             this.loadLastAbstractNo()
//           }
//         },
//         { label: 'ORCID ID', key: 'orcidId', placeholder: '0000-0000-0000-0000' }
//       ],
//       coAuthorFields: [
//         { label: 'Full Name', key: 'coAuthorName', placeholder: 'Enter name' },
//         { label: 'Email', key: 'coAuthorEmail', placeholder: 'name@email.com' },
//         { label: 'Affiliation', key: 'coAuthorAffiliation', placeholder: 'Enter affiliation', span: 8 },
//         {
//           label: 'Select Country',
//           key: 'coAuthorCountry',
//           type: 'select',
//           showSearch: true,
//           options: Countries,
//           keyAccessor: x => x.name,
//           valueAccessor: x => x.name,
//           placeholder: 'Select Country',
//           span: 8,
//           onChange: val => {
//             setFieldsValue({ coAuthorCountry: val })
//           }
//         },
//         { label: 'ORCID ID', key: 'coAuthorOrcid', placeholder: '0000-0000-0000-0000', span: 8 }
//       ]
//     }
//
//     const columns = [
//       { title: 'Name', dataIndex: 'name', key: 'name' },
//       { title: 'Affiliation', dataIndex: 'affiliation' },
//       { title: 'Email', dataIndex: 'email' },
//       { title: 'Country', dataIndex: 'country', key: 'country' },
//       { title: 'ORCID ID', dataIndex: 'orcidId', key: 'orcidId' },
//       {
//         title: 'Action',
//         render: (_, __, index) => (
//           <Tooltip title='Remove'>
//             <a className={'btn btn-danger btn-sm round'}
//                onClick={() => this.removeAuthorSubmit(index)}>
//               <Icon type={'close'} />
//             </a>
//           </Tooltip>
//         )
//       }
//     ]
//
//     return (
//       // <PageHeaderWrapper title={'Add Abstract'}>
//       <PageHeaderWrapper title={pageTitle}>
//         <Card bordered={false}>
//           <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
//             <Row gutter={24}>
//               <Col span={12}>
//                 <Card title={<span><Icon type='file-text' /> 1. Abstract Information</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     {inputSchma.abstractFields.map((item, key) => (
//                       <Col span={item.span || 12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//                     <Col span={12}>
//                       <Form.Item {...formItemLayout} label='Keywords (up to 6) *'>
//                         {getFieldDecorator('keywords', {
//                           rules: [{ required: true, message: 'Please enter keywords!' }]
//                         })(
//                           <Select
//                             mode='tags'
//                             style={{ width: '100%' }}
//                             placeholder='Add keyword and press Enter'
//                             tokenSeparators={[',']}
//                             dropdownStyle={{ display: 'none' }}
//                           />
//                         )}
//                       </Form.Item>
//                     </Col>
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='edit' /> 2. Abstract Content & Files</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     <Col span={24}>
//                       <InputBox title={'Abstract Content*'}>
//                         <CustomCkEditor feeds={mentionsFeeds} html={abstract} placeholder='Write your abstract here...'
//                                         onChange={data => this.setState({ abstract: data })} />
//                       </InputBox>
//                     </Col>
//                     {/*<Col span={24} style={{ marginTop: 20 }}>*/}
//                     {/*  <Row gutter={8}>*/}
//                     {/*    <Col span={8}><InputBox title='Abstract File*'><Input type='file' name='abstractFile'*/}
//                     {/*                                                          key={fileKey}*/}
//                     {/*                                                          onChange={this.chooseDocument} /></InputBox></Col>*/}
//                     {/*    /!*<Col span={8}><InputBox title="Copyright Form"><Input type="file" name="copyrightForm" key={fileKey} onChange={this.chooseDocument} /></InputBox></Col>*!/*/}
//                     {/*    <Col span={8}>*/}
//                     {/*      <InputBox title='Copyright Form*'>*/}
//                     {/*        <Input type='file' name='copyrightForm' key={fileKey} onChange={this.chooseDocument} />*/}
//                     {/*      </InputBox>*/}
//                     {/*    </Col>*/}
//                     {/*    <Col span={8}>*/}
//                     {/*      <InputBox title='Supporting File'><Input type='file' name='supportingFile'*/}
//                     {/*                                                           key={fileKey}*/}
//                     {/*                                                           onChange={this.chooseDocument} /></InputBox></Col>*/}
//                     {/*  </Row>*/}
//                     {/*</Col>*/}
//                     <Col span={24} style={{ marginTop: 20 }}>
//                       <Row gutter={8}>
//                         <Col span={8}>
//                           <InputBox title='Abstract File*'>
//                             <Input type='file' name='abstractFile' key={fileKey} onChange={this.chooseDocument} />
//                           </InputBox>
//                         </Col>
//
//                         {!isProceedFlow && (
//                           <React.Fragment>
//                             <Col span={8}>
//                               <InputBox title='Copyright Form*'>
//                                 <Input type='file' name='copyrightForm' key={fileKey} onChange={this.chooseDocument} />
//                               </InputBox>
//                             </Col>
//                             <Col span={8}>
//                               <InputBox title='Supporting File'>
//                                 <Input type='file' name='supportingFile' key={fileKey} onChange={this.chooseDocument} />
//                               </InputBox>
//                             </Col>
//                           </React.Fragment>
//                         )}
//                       </Row>
//                     </Col>
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='message' /> 3. Speaker Note</span>} bordered={true}>
//                   <GetEachFormFields
//                     item={{
//                       label: 'Short Biography / Speaker Note',
//                       key: 'speakerNote',
//                       type: 'textArea',
//                       placeholder: 'Brief bio or speaker note (max 150 words)',
//                       rows: 4
//                     }}
//                     getFieldDecorator={getFieldDecorator}
//                     formItemLayout={formItemLayout}
//                   />
//                 </Card>
//               </Col>
//
//               <Col span={12}>
//                 <Card title={<span><Icon type='user' /> 4. Corresponding Author Details</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     {inputSchma.authorFields.map((item, key) => (
//                       <Col span={12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='team' /> 5. Co-authors</span>} bordered={true}>
//                   <Row gutter={8}>
//                     {inputSchma.coAuthorFields.map((item, key) => (
//                       <Col span={item.span || 12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//                     <Col span={24} style={{ marginTop: 10 }}>
//                       <a onClick={this.addMoreAuthor} type='primary' className={'btn btn-block btn-default'}><Icon
//                         type='plus' /> Add Co-Author
//                         to List</a>
//                       <Table columns={columns} dataSource={authors} pagination={false} size='small' bordered
//                              style={{ marginTop: 15 }} rowKey={(r, i) => i} />
//                     </Col>
//                   </Row>
//                 </Card>
//               </Col>
//
//               {/* SUBMIT BUTTON */}
//               <Col span={24} style={{ textAlign: 'left', marginTop: '32px' }}>
//                 <Form.Item>
//                   <Button
//                     type='primary'
//                     htmlType='submit'
//                     size='medium'
//                     loading={loading}
//                   >
//                     SUBMIT
//                   </Button>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Form>
//         </Card>
//       </PageHeaderWrapper>
//     )
//   }
// }
//
// const mapStateToProps = ({ global, router }) => ({
//   loading: global.buttonLoading,
//   pathname: router && router.location ? router.location.pathname : window.location.pathname
// })
//
// export default connect(mapStateToProps)(AddAbstract)
//
// import {
//   Button,
//   Card,
//   Col,
//   Form,
//   Icon,
//   Input,
//   notification,
//   Row,
//   Select,
//   Table,
//   Tooltip,
//   Tag // 🟢 Imported Tag
// } from 'antd'
// import _ from 'lodash'
// import moment from 'moment'
// import { push } from 'connected-react-router'
// import React, { PureComponent } from 'react'
//
// import { connect } from 'react-redux'
// import GetEachFormFields from '../../components/_utils/appFormUtils'
// import {getUrlParams } from '../../routes'
// import {
//   createAbstractFxn,
//   lastAbstractNo,
//   FetchSingleOnlineAbstractAction,
//   proceedAbstractSubmissionFxn
// } from './actions'
// import { searchKeyword } from '../editArticle/actions'
// import AddKeyword from '../editArticle/addKeyword'
//
// import PageHeaderWrapper from '../../components/PageHeaderWrapper'
// import {
//   chooseEmailModalFxn,
//   Countries,
//   CustomCkEditor,
//   DesignationList,
//   InputBox, issueTypeList,
//   mentionsFeeds,
//   NotificationBox,
// } from '../../components/_utils/appUtils'
// import { JournalList } from '../journals/actions'
//
// @Form.create()
// class AddAbstract extends PureComponent {
//   state = {
//     journalListArr: [],
//     authors: [],
//     abstractFile: {},
//     copyrightForm: {},
//     supportingFile: {},
//     fileKey: moment(),
//     abstract: '',
//     titleHtml: '',
//     lastAbstractNo: '',
//     keywords: [],
//     keywordList: [],
//     open4: false
//   }
//
//   keywordEvents = {
//     getKeyword: async value => {
//       if (value) {
//         let { data } = await searchKeyword({ keyword: value })
//         if (data) {
//           this.setState({ keywordList: data })
//         }
//       }
//     },
//     chooseKeyword: value => {
//       let clData = _.clone(this.state.keywords) || []
//       let clDataList = _.clone(this.state.keywordList)
//       let findData = _.find(clDataList, item => item._id == value.key)
//
//       if (!clData.some(item => item.keywordId === findData._id)) {
//         clData.push({
//           keywordId: findData._id,
//           keyword: findData.keyword,
//           slugKeyword: findData.slugKeyword
//         })
//       }
//       this.setState({ keywords: clData, keywordList: [] })
//     },
//     removeKeyword: id => {
//       let clData = _.clone(this.state.keywords)
//       clData = _.reject(clData, item => item.keywordId == id)
//       this.setState({ keywords: clData })
//     }
//   }
//
//   events = {
//     onCloseKeyword: (newKeywordData) => {
//       if (newKeywordData && newKeywordData._id) {
//         let clData = _.clone(this.state.keywords) || []
//         clData.push({
//           keywordId: newKeywordData._id,
//           keyword: newKeywordData.keyword,
//           slugKeyword: newKeywordData.slugKeyword
//         })
//         this.setState({ keywords: clData, open4: false })
//       } else {
//         this.setState({ open4: false })
//       }
//     },
//     showKeywordDrawer: () => {
//       this.setState({ open4: true })
//     }
//   }
//
//   updateDocumentTitle = () => {
//     const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//     const isEditFlow = getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     if (isProceedFlow) {
//       document.title = 'Proceed Abstract Submission - Arcc Journals'
//     } else if (isEditFlow) {
//       document.title = 'Edit Abstract - Arcc Journals'
//     } else {
//       document.title = 'Add Abstract - Arcc Journals'
//     }
//   }
//
//   componentDidMount() {
//     this.loadJournalList()
//     this.props.form.setFieldsValue({ submittedDate: moment() })
//     this.loadLastAbstractNo()
//     this.updateDocumentTitle()
//
//     const params = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     if (params && params.id) {
//       this.loadAndPrefillAbstractData(params.id)
//     }
//   }
//
//   componentDidUpdate(prevProps) {
//     if (this.props.pathname !== prevProps.pathname) {
//       const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//       document.title = isProceedFlow ? 'Proceed Abstract Submission - Arcc Journals' : 'Add Abstract - Arcc Journals'
//     }
//
//     const prevParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', prevProps.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', prevProps.pathname)
//     const currentParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
//       getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)
//
//     const prevId = prevParams ? prevParams.id : null
//     const currentId = currentParams ? currentParams.id : null
//
//     if (currentId && currentId !== prevId) {
//       this.loadAndPrefillAbstractData(currentId)
//     }
//   }
//
//   loadAndPrefillAbstractData = async (id) => {
//     const { dispatch, form: { setFieldsValue } } = this.props
//
//     let resp = await dispatch(FetchSingleOnlineAbstractAction(id))
//
//     if (resp && resp.success && resp.data) {
//       const record = resp.data
//
//       let journalValue = record.journal
//       if (journalValue && typeof journalValue === 'object') {
//         journalValue = journalValue._id
//       }
//       setFieldsValue({
//         journal: journalValue,
//         issueType: record.issueType,
//         titleOfAbstract: record.titleOfAbstract,
//         researchArea: record.researchArea,
//         publicationCharges: record.publicationCharges,
//         abstractId: record.abstractNo || record.abstractId,
//         authorName: record.authorName,
//         email: record.email,
//         mobile: record.mobile,
//         institution: record.institution,
//         designation: record.designation,
//         country: record.country,
//         orcidId: record.orcidId,
//         speakerNote: record.speakerNote
//       })
//       let safeKeywords = (record.keywords || []).map(kw => {
//         if (typeof kw === 'string') {
//           return {
//             keywordId: kw,
//             keyword: kw,
//             slugKeyword: kw.toLowerCase().replace(/\s+/g, '-')
//           };
//         }
//         return kw;
//       });
//       this.setState({
//         authors: record.coAuthors || [],
//         abstract: record.abstract || '',
//         titleHtml: record.titleOfAbstract || '',
//         // keywords: record.keywords || []
//         keywords: safeKeywords
//       })
//     }
//   }
//
//   loadJournalList = async () => {
//     let { data } = await JournalList()
//     this.setState({ journalListArr: data || [] })
//   }
//
//   chooseDocument = e => {
//     let { name, files } = e.target
//     if (files && files.length) {
//       this.setState({ [name]: files[0] })
//     }
//   }
//
//   loadLastAbstractNo = async () => {
//     let { form: { getFieldValue }, dispatch } = this.props
//
//     let selectedJournal = getFieldValue('journal')
//
//     if (!selectedJournal) return;
//
//     let payload = { journalId: selectedJournal }
//     let resp = await dispatch(lastAbstractNo(payload))
//
//     if (resp) {
//       this.setState({ lastAbstractNo: resp })
//     } else {
//       this.setState({ lastAbstractNo: 'No previous abstracts' })
//     }
//   }
//
//   addMoreAuthor = () => {
//     const { form: { getFieldsValue, setFieldsValue } } = this.props
//     const coAuthorFields = [
//       'coAuthorName',
//       'coAuthorEmail',
//       'coAuthorAffiliation',
//       'coAuthorCountry',
//       'coAuthorOrcid'
//     ]
//
//     const values = getFieldsValue(coAuthorFields)
//
//     if (!values.coAuthorName || !values.coAuthorEmail || !values.coAuthorAffiliation || !values.coAuthorCountry) {
//       notification.error({
//         message: 'Missing Co-Author Fields',
//         description: 'Please fill in Full Name, Email, Affiliation, and Country before adding.'
//       })
//       return
//     }
//
//     let cloneAuthors = _.clone(this.state.authors)
//     cloneAuthors.push({
//       name: values.coAuthorName,
//       email: values.coAuthorEmail,
//       affiliation: values.coAuthorAffiliation,
//       country: values.coAuthorCountry,
//       orcidId: values.coAuthorOrcid
//     })
//
//     this.setState({ authors: cloneAuthors }, () => {
//       setFieldsValue({
//         coAuthorName: '',
//         coAuthorEmail: '',
//         coAuthorAffiliation: '',
//         coAuthorCountry: undefined,
//         coAuthorOrcid: ''
//       })
//     })
//   }
//
//   removeAuthorSubmit = index => {
//     let cloneAuthors = _.clone(this.state.authors)
//     cloneAuthors.splice(index, 1)
//     this.setState({ authors: cloneAuthors })
//   }
//
//   handleSubmit = e => {
//     const { dispatch, form } = this.props
//     e.preventDefault()
//
//     form.validateFieldsAndScroll(async (err, valData) => {
//       if (!err) {
//         const { authors, abstract, titleHtml, abstractFile, copyrightForm, supportingFile, keywords } = this.state
//         const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//
//         // 🟢 Keyword Validation
//         if (!keywords || keywords.length === 0) {
//           notification.error({ message: 'Required', description: 'Please add at least one keyword.' })
//           return
//         }
//
//         const cleanValData = _.omit(valData, [
//           'coAuthorName',
//           'coAuthorEmail',
//           'coAuthorAffiliation',
//           'coAuthorCountry',
//           'coAuthorOrcid'
//         ])
//
//         const payload = {
//           ...cleanValData,
//           coAuthors: authors,
//           titleOfAbstract: titleHtml || valData.titleOfAbstract,
//           abstract: abstract,
//           keywords: keywords, // 🟢 Submitting from State
//           orcidId: valData.orcidId,
//           abstractId: valData.abstractId,
//           id: isProceedFlow ? isProceedFlow.id : null
//         }
//
//         if (!abstractFile || !abstractFile.name) {
//           notification.error({ message: 'Please select an Abstract File' })
//           return
//         }
//         if (!isProceedFlow && (!copyrightForm || !copyrightForm.name)) {
//           notification.error({ message: 'Please select a Copyright Form' })
//           return
//         }
//         chooseEmailModalFxn({
//           title: isProceedFlow ? 'Send Acknowledgement' : 'Send Abstract Submission Email',
//           callback: async (email) => {
//             let fd = new FormData()
//             payload.fromEmail = email
//             payload.template = isProceedFlow ? 'abstractProceedAcknowledgement' : 'abstractSubmissionAcknowledgement'
//
//             let response
//
//             if (isProceedFlow) {
//               payload.status = 'Processed'
//               fd.append('obj', JSON.stringify(payload))
//               fd.append('abstractFile', abstractFile)
//               if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//               if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//               response = await dispatch(proceedAbstractSubmissionFxn(fd))
//             } else {
//               fd.append('abstract', JSON.stringify(payload))
//               fd.append('abstractFile', abstractFile)
//               if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
//               if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
//               response = await dispatch(createAbstractFxn(fd))
//             }
//
//             if (response && response.success) {
//               NotificationBox({
//                 title: isProceedFlow ? 'Abstract Processed Successfully' : 'Abstract Submitted Successfully',
//                 callback: () => {
//                   form.resetFields()
//                   this.setState({ authors: [], abstract: '', titleHtml: '', fileKey: moment(), keywords: [] })
//                   form.setFieldsValue({ submittedDate: moment() })
//                   this.loadLastAbstractNo()
//                   dispatch(push('/abstract/submittedAbstracts'))
//                 }
//               })
//             } else {
//               notification.error({ message: (response && response.message) || 'Submission failed' })
//             }
//           }
//         })
//       }
//     })
//   }
//
//   render() {
//     const { form: { getFieldDecorator, setFieldsValue }, loading } = this.props
//     const { journalListArr, authors, abstract, fileKey, lastAbstractNo, keywords } = this.state
//     const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
//     const pageTitle = isProceedFlow ? 'Proceed Abstract Submission' : 'Add Abstract'
//
//     document.title = `${pageTitle} - Arcc Journals`
//
//     const formItemLayout = {
//       labelCol: { span: 24 },
//       wrapperCol: { span: 24 }
//     }
//
//     const inputSchma = {
//       abstractFields: [
//         {
//           label: 'Journal / Event',
//           key: 'journal',
//           required: true,
//           showSearch: true,
//           options: journalListArr,
//           keyAccessor: x => x._id,
//           valueAccessor: x => x.name,
//           placeholder: 'Select Journal',
//           type: 'select',
//           onChange: val => {
//             setFieldsValue({ journal: val })
//             this.loadLastAbstractNo()
//           }
//         },
//         {
//           label: 'Issue Type',
//           key: 'issueType',
//           required: true,
//           type: 'select',
//           options: issueTypeList,
//           placeholder: 'Select Issue Type',
//           onChange: val => {
//             setFieldsValue({ issueType: val })
//           }
//         },
//         {
//           label: 'Title of Abstract',
//           key: 'titleOfAbstract',
//           required: true,
//           span: 24,
//           type: 'text',
//           placeholder: 'Enter the title of your abstract',
//           onChange: (e) => {
//             const value = e.target.value
//             setFieldsValue({ titleOfAbstract: value })
//             this.setState({ titleHtml: value })
//           }
//         },
//         {
//           label: 'Research Area',
//           key: 'researchArea',
//           required: true,
//           type: 'text',
//           placeholder: 'Select Research Area',
//           span: 12
//         },
//         {
//           label: 'Abstract No',
//           key: 'abstractId',
//           placeholder: 'Enter Abstract No',
//           onChange: (val) => {
//             setFieldsValue({ abstractId: val.target.value.toUpperCase() });
//           },
//           extraBox: (
//             <React.Fragment>
//               {lastAbstractNo ? (
//                 <label
//                   className={'label label-success'}
//                   style={{ background: '#52c41a', color: '#fff', padding: '2px 8px', borderRadius: '4px' }}
//                 >
//                   {lastAbstractNo}
//                 </label>
//               ) : null}
//             </React.Fragment>
//           )
//         },
//         {
//           label: 'Publication Charges',
//           key: 'publicationCharges',
//           required: true,
//           type: 'number',
//           placeholder: 'Enter Publication Charges',
//           span: 12
//         },
//       ],
//       authorFields: [
//         { label: 'Author Name', key: 'authorName', required: true, placeholder: 'Full name of the corresponding author' },
//         { label: 'Email', key: 'email', required: true, placeholder: 'name@email.com' },
//         { label: 'Mobile Number', key: 'mobile', required: true, placeholder: 'enter mobile no.' },
//         { label: 'Institution / Affiliation', required: true, key: 'institution', placeholder: 'Enter your institution' },
//         {
//           label: 'Designation',
//           key: 'designation',
//           type: 'select',
//           required: true,
//           options: DesignationList,
//           placeholder: 'Select Designation',
//           onChange: val => { setFieldsValue({ designation: val }) }
//         },
//         {
//           label: 'Select Country',
//           key: 'country',
//           required: true,
//           type: 'select',
//           options: Countries,
//           keyAccessor: x => x.name,
//           valueAccessor: x => x.name,
//           showSearch: true,
//           onChange: val => {
//             setFieldsValue({ country: val })
//             this.loadLastAbstractNo()
//           }
//         },
//         { label: 'ORCID ID', key: 'orcidId', placeholder: '0000-0000-0000-0000' }
//       ],
//       coAuthorFields: [
//         { label: 'Full Name', key: 'coAuthorName', placeholder: 'Enter name' },
//         { label: 'Email', key: 'coAuthorEmail', placeholder: 'name@email.com' },
//         { label: 'Affiliation', key: 'coAuthorAffiliation', placeholder: 'Enter affiliation', span: 8 },
//         {
//           label: 'Select Country',
//           key: 'coAuthorCountry',
//           type: 'select',
//           showSearch: true,
//           options: Countries,
//           keyAccessor: x => x.name,
//           valueAccessor: x => x.name,
//           placeholder: 'Select Country',
//           span: 8,
//           onChange: val => { setFieldsValue({ coAuthorCountry: val }) }
//         },
//         { label: 'ORCID ID', key: 'coAuthorOrcid', placeholder: '0000-0000-0000-0000', span: 8 }
//       ]
//     }
//
//     const columns = [
//       { title: 'Name', dataIndex: 'name', key: 'name' },
//       { title: 'Affiliation', dataIndex: 'affiliation' },
//       { title: 'Email', dataIndex: 'email' },
//       { title: 'Country', dataIndex: 'country', key: 'country' },
//       { title: 'ORCID ID', dataIndex: 'orcidId', key: 'orcidId' },
//       {
//         title: 'Action',
//         render: (_, __, index) => (
//           <Tooltip title='Remove'>
//             <a className={'btn btn-danger btn-sm round'}
//                onClick={() => this.removeAuthorSubmit(index)}>
//               <Icon type={'close'} />
//             </a>
//           </Tooltip>
//         )
//       }
//     ]
//
//     return (
//       <PageHeaderWrapper title={pageTitle}>
//         <Card bordered={false}>
//           <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
//             <Row gutter={24}>
//               <Col span={12}>
//                 <Card title={<span><Icon type='file-text' /> 1. Abstract Information</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     {inputSchma.abstractFields.map((item, key) => (
//                       <Col span={item.span || 12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//
//                     {/* 🟢 NEW UI: Dynamic Keyword Search & Tags */}
//                     <Col span={24}>
//                       <Form.Item {...formItemLayout} label='Keywords (up to 6) *'>
//                         <Row gutter={8}>
//                           <Col span={16}>
//                             <Select
//                               showSearch={true}
//                               filterOption={false}
//                               labelInValue
//                               value={undefined}
//                               onChange={this.keywordEvents.chooseKeyword}
//                               onSearch={this.keywordEvents.getKeyword}
//                               placeholder='Search existing keywords...'>
//                               {this.state.keywordList &&
//                               this.state.keywordList.map(item => (
//                                 <Select.Option key={item._id}>{item.keyword}</Select.Option>
//                               ))}
//                             </Select>
//                           </Col>
//                           <Col span={8}>
//                             <Button type="primary" onClick={this.events.showKeywordDrawer} block>
//                               Add Keyword
//                             </Button>
//                           </Col>
//                           <Col span={24} style={{ marginTop: 8 }}>
//                             {keywords && keywords.map((item, i) => (
//                               <Tag
//                                 key={i}
//                                 closable
//                                 color="blue"
//                                 onClose={(e) => {
//                                   e.preventDefault();
//                                   this.keywordEvents.removeKeyword(item.keywordId);
//                                 }}>
//                                 {item.keyword}
//                               </Tag>
//                             ))}
//                           </Col>
//                         </Row>
//                       </Form.Item>
//                     </Col>
//
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='edit' /> 2. Abstract Content & Files</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     <Col span={24}>
//                       <InputBox title={'Abstract Content*'}>
//                         <CustomCkEditor feeds={mentionsFeeds} html={abstract} placeholder='Write your abstract here...'
//                                         onChange={data => this.setState({ abstract: data })} />
//                       </InputBox>
//                     </Col>
//                     <Col span={24} style={{ marginTop: 20 }}>
//                       <Row gutter={8}>
//                         <Col span={8}>
//                           <InputBox title='Abstract File*'>
//                             <Input type='file' name='abstractFile' key={fileKey} onChange={this.chooseDocument} />
//                           </InputBox>
//                         </Col>
//
//                         {!isProceedFlow && (
//                           <React.Fragment>
//                             <Col span={8}>
//                               <InputBox title='Copyright Form*'>
//                                 <Input type='file' name='copyrightForm' key={fileKey} onChange={this.chooseDocument} />
//                               </InputBox>
//                             </Col>
//                             <Col span={8}>
//                               <InputBox title='Supporting File'>
//                                 <Input type='file' name='supportingFile' key={fileKey} onChange={this.chooseDocument} />
//                               </InputBox>
//                             </Col>
//                           </React.Fragment>
//                         )}
//                       </Row>
//                     </Col>
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='message' /> 3. Speaker Note</span>} bordered={true}>
//                   <GetEachFormFields
//                     item={{
//                       label: 'Short Biography / Speaker Note',
//                       key: 'speakerNote',
//                       type: 'textArea',
//                       placeholder: 'Brief bio or speaker note (max 150 words)',
//                       rows: 4
//                     }}
//                     getFieldDecorator={getFieldDecorator}
//                     formItemLayout={formItemLayout}
//                   />
//                 </Card>
//               </Col>
//
//               <Col span={12}>
//                 <Card title={<span><Icon type='user' /> 4. Corresponding Author Details</span>} bordered={true}
//                       style={{ marginBottom: '24px' }}>
//                   <Row gutter={16}>
//                     {inputSchma.authorFields.map((item, key) => (
//                       <Col span={12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//                   </Row>
//                 </Card>
//
//                 <Card title={<span><Icon type='team' /> 5. Co-authors</span>} bordered={true}>
//                   <Row gutter={8}>
//                     {inputSchma.coAuthorFields.map((item, key) => (
//                       <Col span={item.span || 12} key={key}>
//                         <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
//                                            formItemLayout={formItemLayout} />
//                       </Col>
//                     ))}
//                     <Col span={24} style={{ marginTop: 10 }}>
//                       <a onClick={this.addMoreAuthor} type='primary' className={'btn btn-block btn-default'}><Icon
//                         type='plus' /> Add Co-Author
//                         to List</a>
//                       <Table columns={columns} dataSource={authors} pagination={false} size='small' bordered
//                              style={{ marginTop: 15 }} rowKey={(r, i) => i} />
//                     </Col>
//                   </Row>
//                 </Card>
//               </Col>
//
//               <Col span={24} style={{ textAlign: 'left', marginTop: '32px' }}>
//                 <Form.Item>
//                   <Button
//                     type='primary'
//                     htmlType='submit'
//                     size='medium'
//                     loading={loading}
//                   >
//                     SUBMIT
//                   </Button>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Form>
//
//           {/* 🟢 THE ADD KEYWORD DRAWER */}
//           {this.state.open4 ? (
//             <AddKeyword
//               visible={this.state.open4}
//               onClose={this.events.onCloseKeyword}
//             />
//           ) : null}
//
//         </Card>
//       </PageHeaderWrapper>
//     )
//   }
// }
//
// const mapStateToProps = ({ global, router }) => ({
//   loading: global.buttonLoading,
//   pathname: router && router.location ? router.location.pathname : window.location.pathname
// })
//
// export default connect(mapStateToProps)(AddAbstract)


import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Row,
  Select,
  Table,
  Tooltip,
  Popconfirm,
  Tag
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { push } from 'connected-react-router'
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import {getUrlParams } from '../../routes'
import {
  createAbstractFxn,
  lastAbstractNo,
  FetchSingleOnlineAbstractAction,
  proceedAbstractSubmissionFxn
} from './actions'
import { searchKeyword } from '../editArticle/actions'
import AddKeyword from '../editArticle/addKeyword'

import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox, issueTypeList,
  mentionsFeeds,
  NotificationBox,
} from '../../components/_utils/appUtils'
import { JournalList } from '../journals/actions'
import { listAllEventsAction } from '../events/actions'

@Form.create()
class AddAbstract extends PureComponent {
  state = {
    journalListArr: [],
    eventListArr: [], // 🟢 Added for events
    authors: [],
    abstractFile: {},
    copyrightForm: {},
    supportingFile: {},
    fileKey: moment(),
    abstract: '',
    titleHtml: '',
    lastAbstractNo: '',
    keywords: [],
    keywordList: [],
    open4: false
  }

  keywordEvents = {
    getKeyword: async value => {
      if (value) {
        let { data } = await searchKeyword({ keyword: value })
        if (data) {
          this.setState({ keywordList: data })
        }
      }
    },
    chooseKeyword: value => {
      let clData = _.clone(this.state.keywords) || []
      let clDataList = _.clone(this.state.keywordList)
      let findData = _.find(clDataList, item => item._id == value.key)

      if (!clData.some(item => item.keywordId === findData._id)) {
        clData.push({
          keywordId: findData._id,
          keyword: findData.keyword,
          slugKeyword: findData.slugKeyword
        })
      }
      this.setState({ keywords: clData, keywordList: [] })
    },
    removeKeyword: id => {
      let clData = _.clone(this.state.keywords)
      clData = _.reject(clData, item => item.keywordId == id)
      this.setState({ keywords: clData })
    }
  }

  events = {
    onCloseKeyword: (newKeywordData) => {
      if (newKeywordData && newKeywordData._id) {
        let clData = _.clone(this.state.keywords) || []
        clData.push({
          keywordId: newKeywordData._id,
          keyword: newKeywordData.keyword,
          slugKeyword: newKeywordData.slugKeyword
        })
        this.setState({ keywords: clData, open4: false })
      } else {
        this.setState({ open4: false })
      }
    },
    showKeywordDrawer: () => {
      this.setState({ open4: true })
    }
  }

  updateDocumentTitle = () => {
    const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
    const isEditFlow = getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)

    if (isProceedFlow) {
      document.title = 'Proceed Abstract Submission - Arcc Journals'
    } else if (isEditFlow) {
      document.title = 'Edit Abstract - Arcc Journals'
    } else {
      document.title = 'Add Abstract - Arcc Journals'
    }
  }

  componentDidMount() {
    this.loadJournalList()
    this.loadEventList() // 🟢 Renamed to avoid action conflict
    this.props.form.setFieldsValue({ submittedDate: moment() })
    this.loadLastAbstractNo()
    this.updateDocumentTitle()

    const params = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
      getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)

    if (params && params.id) {
      this.loadAndPrefillAbstractData(params.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.pathname !== prevProps.pathname) {
      const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
      document.title = isProceedFlow ? 'Proceed Abstract Submission - Arcc Journals' : 'Add Abstract - Arcc Journals'
    }

    const prevParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', prevProps.pathname) ||
      getUrlParams('onlineAbstractsGroup.abstractEdit', prevProps.pathname)
    const currentParams = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname) ||
      getUrlParams('onlineAbstractsGroup.abstractEdit', this.props.pathname)

    const prevId = prevParams ? prevParams.id : null
    const currentId = currentParams ? currentParams.id : null

    if (currentId && currentId !== prevId) {
      this.loadAndPrefillAbstractData(currentId)
    }
  }

  loadAndPrefillAbstractData = async (id) => {
    const { dispatch, form: { setFieldsValue } } = this.props

    let resp = await dispatch(FetchSingleOnlineAbstractAction(id))

    if (resp && resp.success && resp.data) {
      const record = resp.data

      // let journalValue = record.journal
      // if (journalValue && typeof journalValue === 'object') {
      //   journalValue = journalValue._id
      // }
      let journalValue = record.eventId || record.journal;

      if (journalValue && typeof journalValue === 'object') {
        journalValue = journalValue._id
      }
      setFieldsValue({
        journal: journalValue,
        issueType: record.issueType,
        titleOfAbstract: record.titleOfAbstract,
        researchArea: record.researchArea,
        publicationCharges: record.publicationCharges,
        abstractId: record.abstractNo || record.abstractId,
        authorName: record.authorName,
        email: record.email,
        mobile: record.mobile,
        institution: record.institution,
        designation: record.designation,
        country: record.country,
        orcidId: record.orcidId,
        speakerNote: record.speakerNote
      })
      let safeKeywords = (record.keywords || []).map(kw => {
        if (typeof kw === 'string') {
          return {
            keywordId: kw,
            keyword: kw,
            slugKeyword: kw.toLowerCase().replace(/\s+/g, '-')
          };
        }
        return kw;
      });
      this.setState({
        authors: record.coAuthors || [],
        abstract: record.abstract || '',
        titleHtml: record.titleOfAbstract || '',
        keywords: safeKeywords
      })
    }
  }

  loadJournalList = async () => {
    let { data } = await JournalList()
    this.setState({ journalListArr: data || [] })
  }

  // 🟢 Renamed method to prevent conflicts with the imported action
  loadEventList = async () => {
    const { dispatch } = this.props;
    let response = await dispatch(listAllEventsAction());
    if (response && response.data) {
      this.setState({ eventListArr: response.data });
    }
  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  loadLastAbstractNo = async () => {
    let { form: { getFieldValue }, dispatch } = this.props

    let selectedJournal = getFieldValue('journal')

    if (!selectedJournal) return;

    let payload = { journalId: selectedJournal }
    let resp = await dispatch(lastAbstractNo(payload))

    if (resp) {
      this.setState({ lastAbstractNo: resp })
    } else {
      this.setState({ lastAbstractNo: 'No previous abstracts' })
    }
  }

  addMoreAuthor = () => {
    const { form: { getFieldsValue, setFieldsValue } } = this.props
    const coAuthorFields = [
      'coAuthorName',
      'coAuthorEmail',
      'coAuthorAffiliation',
      'coAuthorCountry',
      'coAuthorOrcid'
    ]

    const values = getFieldsValue(coAuthorFields)

    if (!values.coAuthorName || !values.coAuthorEmail || !values.coAuthorAffiliation || !values.coAuthorCountry) {
      notification.error({
        message: 'Missing Co-Author Fields',
        description: 'Please fill in Full Name, Email, Affiliation, and Country before adding.'
      })
      return
    }

    let cloneAuthors = _.clone(this.state.authors)
    cloneAuthors.push({
      name: values.coAuthorName,
      email: values.coAuthorEmail,
      affiliation: values.coAuthorAffiliation,
      country: values.coAuthorCountry,
      orcidId: values.coAuthorOrcid
    })

    this.setState({ authors: cloneAuthors }, () => {
      setFieldsValue({
        coAuthorName: '',
        coAuthorEmail: '',
        coAuthorAffiliation: '',
        coAuthorCountry: undefined,
        coAuthorOrcid: ''
      })
    })
  }

  removeAuthorSubmit = index => {
    let cloneAuthors = _.clone(this.state.authors)
    cloneAuthors.splice(index, 1)
    this.setState({ authors: cloneAuthors })
  }



  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const { authors, abstract, titleHtml, abstractFile, copyrightForm, supportingFile, keywords } = this.state
        const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)

        if (!keywords || keywords.length === 0) {
          notification.error({ message: 'Required', description: 'Please add at least one keyword.' })
          return
        }

        const cleanValData = _.omit(valData, [
          'coAuthorName',
          'coAuthorEmail',
          'coAuthorAffiliation',
          'coAuthorCountry',
          'coAuthorOrcid'
        ])

        const payload = {
          ...cleanValData,
          coAuthors: authors,
          titleOfAbstract: titleHtml || valData.titleOfAbstract,
          abstract: abstract,
          keywords: keywords,
          orcidId: valData.orcidId,
          abstractId: valData.abstractId,
          id: isProceedFlow ? isProceedFlow.id : null
        }

        if (!abstractFile || !abstractFile.name) {
          notification.error({ message: 'Please select an Abstract File' })
          return
        }
        if (!isProceedFlow && (!copyrightForm || !copyrightForm.name)) {
          notification.error({ message: 'Please select a Copyright Form' })
          return
        }
        chooseEmailModalFxn({
          title: isProceedFlow ? 'Send Acknowledgement' : 'Send Abstract Submission Email',
          callback: async (email) => {
            let fd = new FormData()
            payload.fromEmail = email
            payload.template = isProceedFlow ? 'abstractProceedAcknowledgement' : 'abstractAcknowledgement'

            let response

            if (isProceedFlow) {
              payload.status = 'Processed'
              fd.append('obj', JSON.stringify(payload))
              fd.append('abstractFile', abstractFile)
              if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
              if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
              response = await dispatch(proceedAbstractSubmissionFxn(fd))
            } else {
              fd.append('abstract', JSON.stringify(payload))
              fd.append('abstractFile', abstractFile)
              if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
              if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)
              response = await dispatch(createAbstractFxn(fd))
            }

            if (response && response.success) {
              NotificationBox({
                title: isProceedFlow ? 'Abstract Processed Successfully' : 'Abstract Submitted Successfully',
                callback: () => {
                  form.resetFields()
                  this.setState({ authors: [], faqs: [], abstract: '', titleHtml: '', fileKey: moment(), keywords: [] })
                  form.setFieldsValue({ submittedDate: moment() })
                  this.loadLastAbstractNo()
                  dispatch(push('/abstract/submittedAbstracts'))
                }
              })
            } else {
              notification.error({ message: (response && response.message) || 'Submission failed' })
            }
          }
        })
      }
    })
  }

  render() {
    const { form: { getFieldDecorator, setFieldsValue }, loading } = this.props
    const { journalListArr, authors, faqs, abstract, fileKey, lastAbstractNo, keywords } = this.state
    const isProceedFlow = getUrlParams('onlineAbstractsGroup.onlineSubmission', this.props.pathname)
    const pageTitle = isProceedFlow ? 'Proceed Abstract Submission' : 'Add Abstract'

    document.title = `${pageTitle} - Arcc Journals`

    const formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }

    const inputSchma = {
      abstractFields: [
        {
          label: 'Journal / Event',
          key: 'journal',
          required: true,
          showSearch: true,
          options: journalListArr,
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          placeholder: 'Select Journal',
          type: 'select',
          onChange: val => {
            setFieldsValue({ journal: val })
            this.loadLastAbstractNo()
          }
        },
        {
          label: 'Issue Type',
          key: 'issueType',
          required: true,
          type: 'select',
          options: issueTypeList,
          placeholder: 'Select Issue Type',
          onChange: val => {
            setFieldsValue({ issueType: val })
          }
        },
        {
          label: 'Title of Abstract',
          key: 'titleOfAbstract',
          required: true,
          span: 24,
          type: 'text',
          placeholder: 'Enter the title of your abstract',
          onChange: (e) => {
            const value = e.target.value
            setFieldsValue({ titleOfAbstract: value })
            this.setState({ titleHtml: value })
          }
        },
        {
          label: 'Research Area',
          key: 'researchArea',
          required: true,
          type: 'text',
          placeholder: 'Select Research Area',
          span: 12
        },
        {
          label: 'Abstract No',
          key: 'abstractId',
          placeholder: 'Enter Abstract No',
          onChange: (val) => {
            setFieldsValue({ abstractId: val.target.value.toUpperCase() });
          },
          extraBox: (
            <React.Fragment>
              {lastAbstractNo ? (
                <label
                  className={'label label-success'}
                  style={{ background: '#52c41a', color: '#fff', padding: '2px 8px', borderRadius: '4px' }}
                >
                  {lastAbstractNo}
                </label>
              ) : null}
            </React.Fragment>
          )
        },
        {
          label: 'Publication Charges',
          key: 'publicationCharges',
          required: true,
          type: 'number',
          placeholder: 'Enter Publication Charges',
          span: 12
        },
      ],
      authorFields: [
        { label: 'Author Name', key: 'authorName', required: true, placeholder: 'Full name of the corresponding author' },
        { label: 'Email', key: 'email', required: true, placeholder: 'name@email.com' },
        { label: 'Mobile Number', key: 'mobile', required: true, placeholder: 'enter mobile no.' },
        { label: 'Institution / Affiliation', required: true, key: 'institution', placeholder: 'Enter your institution' },
        {
          label: 'Designation',
          key: 'designation',
          type: 'select',
          required: true,
          options: DesignationList,
          placeholder: 'Select Designation',
          onChange: val => { setFieldsValue({ designation: val }) }
        },
        {
          label: 'Select Country',
          key: 'country',
          required: true,
          type: 'select',
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          showSearch: true,
          onChange: val => {
            setFieldsValue({ country: val })
            this.loadLastAbstractNo()
          }
        },
        { label: 'ORCID ID', key: 'orcidId', placeholder: '0000-0000-0000-0000' }
      ],
      coAuthorFields: [
        { label: 'Full Name', key: 'coAuthorName', placeholder: 'Enter name' },
        { label: 'Email', key: 'coAuthorEmail', placeholder: 'name@email.com' },
        { label: 'Affiliation', key: 'coAuthorAffiliation', placeholder: 'Enter affiliation', span: 8 },
        {
          label: 'Select Country',
          key: 'coAuthorCountry',
          type: 'select',
          showSearch: true,
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Select Country',
          span: 8,
          onChange: val => { setFieldsValue({ coAuthorCountry: val }) }
        },
        { label: 'ORCID ID', key: 'coAuthorOrcid', placeholder: '0000-0000-0000-0000', span: 8 }
      ]
    }

    const columns = [
      { title: 'Name', dataIndex: 'name', key: 'name' },
      { title: 'Affiliation', dataIndex: 'affiliation' },
      { title: 'Email', dataIndex: 'email' },
      { title: 'Country', dataIndex: 'country', key: 'country' },
      { title: 'ORCID ID', dataIndex: 'orcidId', key: 'orcidId' },
      {
        title: 'Action',
        render: (_, __, index) => (
          <Tooltip title='Remove'>
            <a className={'btn btn-danger btn-sm round'}
               onClick={() => this.removeAuthorSubmit(index)}>
              <Icon type={'close'} />
            </a>
          </Tooltip>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={pageTitle}>
        <Card bordered={false}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
            <Row gutter={24}>
              <Col span={12}>
                <Card title={<span><Icon type='file-text' /> 1. Abstract Information</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>

                    {/* 🟢 NEW UI: Grouped Journal / Event Dropdown */}
                    <Col span={24}>
                      <Form.Item {...formItemLayout} label="Journal / Event">
                        {getFieldDecorator('journal', { rules: [{ required: true, message: 'Please select a Journal or Event!' }] })(
                          <Select
                            showSearch
                            placeholder="Choose Journal / Event"
                            onChange={(val) => {
                              setFieldsValue({ journal: val });
                              this.loadLastAbstractNo();
                            }}
                          >
                            <Select.OptGroup label="Events">
                              {this.state.eventListArr && this.state.eventListArr.map(e => (
                                <Select.Option key={e._id} value={e._id}>{e.eventName}</Select.Option>
                              ))}
                            </Select.OptGroup>
                            <Select.OptGroup label="Journal">
                              {this.state.journalListArr && this.state.journalListArr.map(j => (
                                <Select.Option key={j._id} value={j._id}>{j.name}</Select.Option>
                              ))}
                            </Select.OptGroup>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>

                    {/* 🟢 Render remaining abstract fields (excluding 'journal') */}
                    {inputSchma.abstractFields
                      .filter(item => item.key !== 'journal')
                      .map((item, key) => (
                        <Col span={item.span || 12} key={key}>
                          <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
                                             formItemLayout={formItemLayout} />
                        </Col>
                      ))}

                    {/* 🟢 NEW UI: Dynamic Keyword Search & Tags */}
                    <Col span={24}>
                      <Form.Item {...formItemLayout} label='Keywords (up to 6) *'>
                        <Row gutter={8}>
                          <Col span={16}>
                            <Select
                              showSearch={true}
                              filterOption={false}
                              labelInValue
                              value={undefined}
                              onChange={this.keywordEvents.chooseKeyword}
                              onSearch={this.keywordEvents.getKeyword}
                              placeholder='Search existing keywords...'>
                              {this.state.keywordList &&
                              this.state.keywordList.map(item => (
                                <Select.Option key={item._id}>{item.keyword}</Select.Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={8}>
                            <Button type="primary" onClick={this.events.showKeywordDrawer} block>
                              Add Keyword
                            </Button>
                          </Col>
                          <Col span={24} style={{ marginTop: 8 }}>
                            {keywords && keywords.map((item, i) => (
                              <Tag
                                key={i}
                                closable
                                color="blue"
                                onClose={(e) => {
                                  e.preventDefault();
                                  this.keywordEvents.removeKeyword(item.keywordId);
                                }}>
                                {item.keyword}
                              </Tag>
                            ))}
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col>

                  </Row>
                </Card>

                <Card title={<span><Icon type='edit' /> 2. Abstract Content & Files</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>
                    <Col span={24}>
                      <InputBox title={'Abstract Content*'}>
                        <CustomCkEditor feeds={mentionsFeeds} html={abstract} placeholder='Write your abstract here...'
                                        onChange={data => this.setState({ abstract: data })} />
                      </InputBox>
                    </Col>
                    <Col span={24} style={{ marginTop: 20 }}>
                      <Row gutter={8}>
                        <Col span={8}>
                          <InputBox title='Abstract File*'>
                            <Input type='file' name='abstractFile' key={fileKey} onChange={this.chooseDocument} />
                          </InputBox>
                        </Col>

                        {!isProceedFlow && (
                          <React.Fragment>
                            <Col span={8}>
                              <InputBox title='Copyright Form*'>
                                <Input type='file' name='copyrightForm' key={fileKey} onChange={this.chooseDocument} />
                              </InputBox>
                            </Col>
                            <Col span={8}>
                              <InputBox title='Supporting File'>
                                <Input type='file' name='supportingFile' key={fileKey} onChange={this.chooseDocument} />
                              </InputBox>
                            </Col>
                          </React.Fragment>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Card>

                <Card title={<span><Icon type='message' /> 3. Speaker Note</span>} bordered={true}>
                  <GetEachFormFields
                    item={{
                      label: 'Short Biography / Speaker Note',
                      key: 'speakerNote',
                      type: 'textArea',
                      placeholder: 'Brief bio or speaker note (max 150 words)',
                      rows: 4
                    }}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout}
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card title={<span><Icon type='user' /> 4. Corresponding Author Details</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>
                    {inputSchma.authorFields.map((item, key) => (
                      <Col span={12} key={key}>
                        <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
                                           formItemLayout={formItemLayout} />
                      </Col>
                    ))}
                  </Row>
                </Card>

                <Card title={<span><Icon type='team' /> 5. Co-authors</span>} bordered={true}>
                  <Row gutter={8}>
                    {inputSchma.coAuthorFields.map((item, key) => (
                      <Col span={item.span || 12} key={key}>
                        <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
                                           formItemLayout={formItemLayout} />
                      </Col>
                    ))}
                    <Col span={24} style={{ marginTop: 10 }}>
                      <a onClick={this.addMoreAuthor} type='primary' className={'btn btn-block btn-default'}><Icon
                        type='plus' /> Add Co-Author
                        to List</a>
                      <Table columns={columns} dataSource={authors} pagination={false} size='small' bordered
                             style={{ marginTop: 15 }} rowKey={(r, i) => i} />
                    </Col>
                  </Row>
                </Card>              </Col>

              <Col span={24} style={{ textAlign: 'left', marginTop: '32px' }}>
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    size='medium'
                    loading={loading}
                  >
                    SUBMIT
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          {/* 🟢 THE ADD KEYWORD DRAWER */}
          {this.state.open4 ? (
            <AddKeyword
              visible={this.state.open4}
              onClose={this.events.onCloseKeyword}
            />
          ) : null}

        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  pathname: router && router.location ? router.location.pathname : window.location.pathname
})

export default connect(mapStateToProps)(AddAbstract)